export class GetPublicEntity {
  static readonly type = '[ENTITY] Get entity';
  constructor(public readonly web_domain: string){}
}



